import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { App } from "./app";

ReactDOM.createRoot(document.getElementById("app")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
